@if (isLoading) {
  <div class="tfm-loading">
    <mat-spinner diameter="32"></mat-spinner>
  </div>
} @else {
  <mat-accordion>
    <!-- ── Outer: TFM section — same structure as "Asignatura" ───────────────── -->
    <mat-expansion-panel
      class="course-accordion section-accordion"
      [expanded]="sectionExpanded"
      #tfmSection
      (opened)="sectionExpanded = true"
      (closed)="sectionExpanded = false"
    >
      <mat-expansion-panel-header class="course-accordion__header section-header">
        <div class="course-accordion__title-container section-title-container">
          <div class="course-accordion__left">
            <div class="course-accordion__text">Trabajo de Fin de Máster</div>
          </div>
          <div class="course-accordion__actions">
            <button type="button" class="course-accordion__nav-button">
              <mat-icon class="course-accordion__chevron-icon" [class.rotated]="tfmSection.expanded"> expand_more </mat-icon>
            </button>
          </div>
        </div>
      </mat-expansion-panel-header>

      <!-- Section body: two sub-panels like modules inside a section -->
      <div class="subject-content">
        <div class="tfm-enabled-row">
          <app-enfaf-switch-dark label="Activar TFM para este curso" [control]="$any(form.get('enabled'))"></app-enfaf-switch-dark>
        </div>

        <div class="module-content">
          <!-- ── DRAFT sub-panel — same structure as "Módulo" ───────────────── -->
          <mat-expansion-panel
            class="course-accordion module-accordion"
            [expanded]="draftExpanded"
            #draftPanel
            (opened)="draftExpanded = true"
            (closed)="draftExpanded = false"
          >
            <mat-expansion-panel-header class="course-accordion__header module-header">
              <div class="course-accordion__title-container module-title-container">
                <div class="course-accordion__left">
                  <div class="course-accordion__text">Trabajo Fin de Máster Borrador</div>
                </div>
                <div class="course-accordion__actions">
                  <button type="button" class="course-accordion__nav-button">
                    <mat-icon class="course-accordion__chevron-icon" [class.rotated]="draftPanel.expanded"> expand_more </mat-icon>
                  </button>
                </div>
              </div>
            </mat-expansion-panel-header>

            <div class="module-item-content">
              <app-enfaf-input-file-dragger-dark
                [acceptMultiple]="true"
                [acceptLimit]="10"
                [maxFileSize]="250000000"
                accept="image/*,.pdf,.docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                [title]="'Arrastra o suelta aquí'"
                [buttonText]="'Sube tus archivos'"
                [currentFiles]="draftCurrentFiles"
                [cleanFiles]="cleanDraftFiles"
                (filesDropped)="onSupportFilesDropped($event, 'draft')"
                (currentFileDeleted)="onSupportFileDeleted($event, 'draft')"
              >
              </app-enfaf-input-file-dragger-dark>

              <app-enfaf-textarea-dark
                label="Descripción / instrucciones"
                placeholder="Describe qué debe incluir el borrador..."
                [control]="$any(form.get('draftDescription'))"
              >
              </app-enfaf-textarea-dark>

              <div class="tfm-dates-row">
                <enfaf-datetime-picker-dark
                  color="blue"
                  label="Plazo abierto desde"
                  placeholder="Fecha de entrada"
                  [control]="$any(form.get('draftOpenDate'))"
                >
                </enfaf-datetime-picker-dark>
                <enfaf-datetime-picker-dark
                  color="blue"
                  label="Plazo abierto hasta"
                  placeholder="Fecha de salida"
                  [control]="$any(form.get('draftDueDate'))"
                >
                </enfaf-datetime-picker-dark>
              </div>
            </div>
          </mat-expansion-panel>

          <!-- ── FINAL sub-panel — same structure as "Módulo" ──────────────── -->
          <mat-expansion-panel
            class="course-accordion module-accordion"
            [expanded]="finalExpanded"
            #finalPanel
            (opened)="finalExpanded = true"
            (closed)="finalExpanded = false"
          >
            <mat-expansion-panel-header class="course-accordion__header module-header">
              <div class="course-accordion__title-container module-title-container">
                <div class="course-accordion__left">
                  <div class="course-accordion__text">Trabajo Fin de Máster Final</div>
                </div>
                <div class="course-accordion__actions">
                  <button type="button" class="course-accordion__nav-button">
                    <mat-icon class="course-accordion__chevron-icon" [class.rotated]="finalPanel.expanded"> expand_more </mat-icon>
                  </button>
                </div>
              </div>
            </mat-expansion-panel-header>

            <div class="module-item-content">
              <app-enfaf-input-file-dragger-dark
                [acceptMultiple]="true"
                [acceptLimit]="10"
                [maxFileSize]="250000000"
                accept="image/*,.pdf,.docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                [title]="'Arrastra o suelta aquí'"
                [buttonText]="'Sube tus archivos'"
                [currentFiles]="finalCurrentFiles"
                [cleanFiles]="cleanFinalFiles"
                (filesDropped)="onSupportFilesDropped($event, 'final')"
                (currentFileDeleted)="onSupportFileDeleted($event, 'final')"
              >
              </app-enfaf-input-file-dragger-dark>

              <app-enfaf-textarea-dark
                label="Descripción / instrucciones"
                placeholder="Describe qué debe incluir la entrega final..."
                [control]="$any(form.get('finalDescription'))"
              >
              </app-enfaf-textarea-dark>

              <div class="tfm-dates-row">
                <enfaf-datetime-picker-dark
                  color="blue"
                  label="Plazo abierto desde"
                  placeholder="Fecha de entrada"
                  [control]="$any(form.get('finalOpenDate'))"
                >
                </enfaf-datetime-picker-dark>
                <enfaf-datetime-picker-dark
                  color="blue"
                  label="Plazo abierto hasta"
                  placeholder="Fecha de salida"
                  [control]="$any(form.get('finalDueDate'))"
                >
                </enfaf-datetime-picker-dark>
              </div>
            </div>
          </mat-expansion-panel>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>

  <div class="tfm-save-row">
    <app-enfaf-button [isLoading]="isSaving" (onClick)="saveConfig()"> Guardar configuración TFM </app-enfaf-button>
  </div>
}
